import list from 'src/modules/eventClass/list/eventClassListReducers';
import form from 'src/modules/eventClass/form/eventClassFormReducers';
import view from 'src/modules/eventClass/view/eventClassViewReducers';
import destroy from 'src/modules/eventClass/destroy/eventClassDestroyReducers';
import importerReducer from 'src/modules/eventClass/importer/eventClassImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
